// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

import { useState, useCallback } from 'react';

const STORAGE_KEY = 'clubview_nav_expanded';

function loadExpanded(): Record<string, boolean> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function useNavExpanded() {
  const [expanded, setExpanded] = useState<Record<string, boolean>>(loadExpanded);

  const toggleGroup = useCallback((groupId: string) => {
    setExpanded((prev) => {
      const current = prev[groupId] ?? true;
      const next = { ...prev, [groupId]: !current };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const isExpanded = useCallback(
    (groupId: string, defaultOpen = true) => expanded[groupId] ?? defaultOpen,
    [expanded],
  );

  return { isExpanded, toggleGroup };
}
